import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Button from "@weave-design/button";
import { Link24 } from "@weave-design/icons";
import { ProcessingFailure } from "../../../../processing-failure/processingFailure";
import { ProcessingPane } from "../../../../processing-pane/processingPane";
import { rootElement } from "../../../../shared";
import { LinkedModelFileSelector } from "./linkedModelFileSelector";
import eventBus, { IApplicationEvent } from "../../../eventBus/eventDispatcher";
import repo from "../../../../../Repository";

type Props = {
    modelId: string;
    projectId: string;
};

export const LinkNewModel = ({ modelId }: Props) => {
    const [fileSelectorDialogOpened, setFileSelectorDialogOpened] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [failure, setFailure] = useState("");

    useEffect(() => {
        const onToggleVisibility = (event: IApplicationEvent<boolean>) => {
            if (!event.payload) {
                setFileSelectorDialogOpened(false);
                setInProgress(false);
                setFailure("");
            }
        };

        eventBus.addEventListener("Dextall.LinkedModels.UI.DockingPanelVisibilityChanged", onToggleVisibility);

        return () => {
            eventBus.removeEventListener("Dextall.LinkedModels.UI.DockingPanelVisibilityChanged", onToggleVisibility);
        };
    }, []);

    const linkModel = async (file: File) => {
        setFileSelectorDialogOpened(false);
        setInProgress(true);

        const response = await repo.createLinkedModel(modelId, file);

        setInProgress(false);

        if (response.isSuccess) {
            eventBus.dispatchEvent({ type: "Dextall.LinkedModels.Created", payload: response.item });
        } else {
            setFailure(response.message);
        }
    };

    return (
        <>
            <Button
                className="link-new-model"
                type="primary"
                size="standard"
                title="New model"
                width="grow"
                icon={<Link24 />}
                onClick={() => setFileSelectorDialogOpened(true)}
            />

            {fileSelectorDialogOpened &&
                ReactDOM.createPortal(
                    <LinkedModelFileSelector linkModel={linkModel} cancel={() => setFileSelectorDialogOpened(false)} />,
                    rootElement,
                )}

            {inProgress &&
                ReactDOM.createPortal(
                    <ProcessingPane isVisible message="Uploading linked model..." title="Linked model" />,
                    rootElement,
                )}

            {failure &&
                ReactDOM.createPortal(
                    <ProcessingFailure
                        isVisible
                        title="Linked model"
                        message={failure}
                        closeProcessingErrorDialog={() => setFailure("")}
                    />,
                    rootElement,
                )}
        </>
    );
};
